import { render, staticRenderFns } from "./TripDriverQueue.vue?vue&type=template&id=56fee798"
import script from "./TripDriverQueue.vue?vue&type=script&lang=js"
export * from "./TripDriverQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports